import React from 'react'
import GoogleSignIn from '../../login/components/GoogleSignIn'

import Button from '../../common/components/Button';
import { CrumplePopSignupContext } from '../contexts/CrumplePopSignupContext';
import { axiosGet, axiosPost } from '../../common/js/axios-utility';
import CountryStateSelectNew from '../../common/components/CountryStateSelectNew';
import { errorToast } from '../../common/js/toast-utility';
import { setLoginCookie } from '../../common/js/login-cookie-utility';

export default function BorisSignIn({onComplete}) {
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);
    const form = React.useRef(null);

    const handleBack = () => { };
    let oauthType = '';
    let oauthId = '';

    const handleSubmit = async event => {
        event.preventDefault();
        setMigrationState({...migrationState, processing: true});
        try{
            const user = migrationState.cpopUser;
            const grecapToken = await grecaptcha.execute('6LeQ58wUAAAAAOO3JdYg_gxcIMwN9GXg8cWkz1i_', { action: 'signin' })
            const payload = {
                email: user.email,
                password : form.current.elements.password.value,
                oauthType : oauthType, 
                oauthId : oauthId
            }
            payload['g-recaptcha-response'] = grecapToken;
            const loginResponse = await axiosPost('/loginv3', payload);
            const loginData = loginResponse.data;

            setLoginCookie(loginData);
            setMigrationState({...migrationState, processing: false});
            onComplete(loginData);
        }
        catch(err){
            console.error(err);
            handleSigninError(err);
        }
    }

    const handleGoogleSignIn = async result => {
        if (!result.code){
            errorToast('Failed to sign in with Google. Please try again.');
            return;
        }
        setMigrationState({...migrationState, processing: true});
        try{
            const {data} = await axiosPost('/auth/workos/google/exchange',
                {code: result.code, matchEmail: migrationState.cpopUser.email});
            if (data.status != 'ok'){
                console.error(data);
                throw new Error('login failed');
                //handle seemingly impossible scenario of a user reaching this point without an active bfx weblogin.
                return;
            }
            setLoginCookie(data.data);
            onComplete(data.data);
        }
        catch(err){
            let message = 'Failed to sign in with Google. Please try again.';
            if (err.response && err.response.data == 'email mismatch'){
                message = 'Email does not match. Please sign in using your CrumplePop Email Address.';
            }
            errorToast(message);
            setMigrationState({...migrationState, processing: false});
        }
    }

    const handleSigninError = (error) => {
        const statusCode = error && error.response ? error.response.status : null;
        let loginError = '';
        switch (statusCode) {
            case 401:
                loginError = 'Incorrect Email Address/Password. Please Try Again.';
                break;
            case 430:
                loginError = 'Please enter a valid Email Address.';
                break;
            case 429:
            case 431:
                loginError = 'An error has occurred. Please wait a few minutes and try again.';
                break;
            case 503:
                loginError = 'Sign-in is temporarily unavailable. Please try again in a few minutes.';
                break;
            default:
                loginError = 'Something has gone wrong. Please try again.'
        }
        errorToast(loginError);
        setMigrationState({...migrationState, processing: false});
    }

    return (
        <div className='cpop-signup-container'>
            <GoogleSignIn onComplete={handleGoogleSignIn} />
            <div className='or-header or-header-narrow'>
                <em>Or</em>
            </div>
            <form onSubmit={handleSubmit} ref={form}>
                <div className='form-row'>
                    <div className='form-field'>
                        <label>Boris FX password</label>
                        <input name="password" type="password" autoComplete='password' />
                    </div>
                </div>
                <div className='cpop-signup-buttons text-right'>
                    <Button
                        className='btn-new back-btn'
                        label="Back"
                        onClick={handleBack} />
                    <Button
                        className='btn-new'
                        label="Sign In"
                        processingLabel="Please Wait..."
                        submit />
                </div>
            </form>
        </div>
    )
}
